import SAInput from './SAInput';
import React from 'react';
import {injectIntl} from 'react-intl';

class SAInputLabel extends React.Component {
  render() {
    const {
      intl: { formatMessage },
      name,
      label,
      ...attributes
    } = this.props;
    return (
      <div className="form-field">
        <label htmlFor={name}>{formatMessage({ id: label })}</label>
        <SAInput name={name} {...attributes} />
      </div>
    );
  }
}

export default injectIntl(SAInputLabel);



// WEBPACK FOOTER //
// ./src/components/common/input/SAInputLabel.js